import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { P } from '@components/shared/Typography';
import CartCrossSells from './CartCrossSells';

const CartEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <P $mods={[18]} style={{ marginBottom: 40 }}>
        {t('components.basket-empty')}
      </P>
      <CartCrossSells maxItemsToShow={4} />
    </Container>
  );
};

export default CartEmpty;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 0 20px 0;
  width: 100%;

  & > p {
    opacity: 0.5;
    color: ${Colors.navyBlue};
  }

  @media only screen and (max-width: 768px) {
    padding: 30px 0;
    align-items: center;
  }
`;
